/**
 * Process items to get unique entries based on safeguard ID, keeping the most recent (CRFS2025 version)
 * @param {Array} items - Array of items to process
 * @returns {Array} - Processed unique items with maturity scores
 */
(function($) {
	function processUniqueItems(items) {
	const itemsMap = items.reduce((acc, item) => {
		const safeguardId = item.safeguardid.S;

		// Only answer rows count. Legacy implementation-only rows have no policystatus,
		// and reading policystatus.N of one below threw for the whole project.
		if (!item.policystatus) {
			return acc;
		}

		// If the current item has a newer timestamp or the entry does not exist, update or add it
		if (!acc[safeguardId] || acc[safeguardId].timestamp.S < item.timestamp.S) {
			// Keep the item regardless of policystatus
			acc[safeguardId] = item;
		}

		return acc;
	}, {});

	//console.log("processUniqueItems: ", itemsMap);  // Debug statement to log itemsMap

	// Convert itemsMap to an array and map to calculate maturity score
	// Keep all items, including Not Applicable ones
	return Object.values(itemsMap)
		.map(item => {
			// Calculate maturity score for non-Not Applicable items
			if (parseInt(item.policystatus.N, 10) !== 1) {
				item.maturityscore = window.calculateMaturityScore(parseInt(item.policystatus.N, 10));
			} else {
				// For Not Applicable items, set maturityscore to null but keep the item
				item.maturityscore = null;
			}
			return item;
		});
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = processUniqueItems;
	} else if (typeof window !== 'undefined') {
		window.processUniqueItems = processUniqueItems;
	}

})(jQuery);
